import { render } from "./ForgotPassword.vue?vue&type=template&id=10a52436&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"

import "./ForgotPassword.vue?vue&type=style&index=0&id=10a52436&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a52436"],['__file',"src/components/auth/ForgotPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10a52436"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10a52436', __exports__)) {
    api.reload('10a52436', __exports__)
  }
  
  module.hot.accept("./ForgotPassword.vue?vue&type=template&id=10a52436&scoped=true", () => {
    api.rerender('10a52436', render)
  })

}


export default __exports__